interface LoaderProps {
  size: number;
  borderWidth: number;
  borderColor: string;
  fillColor: string;
}
const LoaderIcon = ({ size, borderWidth, borderColor, fillColor }: LoaderProps) => {
  return (
    <div className="loader">
      <style>
        {`
          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .loader {
            width: ${size};
            height: ${size};
            border: ${borderWidth}px solid ${borderColor};
            border-bottom-color: ${fillColor};
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default LoaderIcon;
